var vms = vms || {};
/*
examples:
vms.info.error('Error message!'); // clears previous errors
vms.info.error(['Error message1!','Error message2!']); // list of errors
vms.info.error('Error message!', true); // appends error
vms.info.success('Success message!'); // clears all previous errors and success msgs
vms.info.clear(); // clears all errors and success msgs
vms.info.alert('Alert message!');
vms.info.alert('Alert message!', function () { vms.info.success('Alert closed!'); });
vms.info.confirm('Confirm action', function (okPressed) { if ( okPressed ) vms.info.success('Action confirmed!'); });
*/
vms.info = {
    alert: function (pMsg, pCallback) {
        apex.message.alert(pMsg.replaceAll("<br />", "\n"), pCallback);
    },
    confirm: function (pMsg, pCallback, pLabels){
        let l_original_messages;
        if (pLabels) {
            l_original_messages = {"APEX.DIALOG.OK":     'OK',
                                   "APEX.DIALOG.CANCEL": 'Cancel'};

            //change the button labels messages
            if (pLabels.ok) pLabels.ok;
            if (pLabels.cancel) pLabels.cancel;

        }
        apex.message.confirm(pMsg, pCallback);

        if (pLabels) {
            //the timeout is required since APEX 19.2 due to a change in the apex.message.confirm
            setTimeout(function () {
                //changes the button labels messages back to their original values
                apex.lang.addMessages({"APEX.DIALOG.OK":     l_original_messages["APEX.DIALOG.OK"]});
                apex.lang.addMessages({"APEX.DIALOG.CANCEL": l_original_messages["APEX.DIALOG.CANCEL"]});
                }, 0);
        }
    },
    clear: function (){
        apex.message.clearErrors();
        apex.message.hidePageSuccess();
    },
    error: function (pErr, pAppend) {
        if (!pAppend) apex.message.clearErrors();
        if (Array.isArray(pErr)) {
            pErr.forEach(msg => {
                apex.message.showErrors({type:"error",location:"page",message: msg});
            });
        } else {
            apex.message.showErrors({type:"error",location:"page",message: pErr});
        }
    },
    success: function (pMsg){
        apex.message.showPageSuccess(pMsg);
    }
}